// Disable easyblocks verbose logging - MUST be first, before any imports
(() => {
  const originalConsoleLog = console.log;
  const originalConsoleDebug = console.debug;
  const originalConsoleInfo = console.info;

  const easyblocksPatterns = [
    "editable data",
    "focused field",
    "meta",
    "compiled config",
    "external data",
    "Existing document",
    "updating the document",
    "no local changes",
  ];

  const shouldFilterLog = (...args: any[]) => {
    const firstArg = args[0];
    if (typeof firstArg === "string") {
      return easyblocksPatterns.some((pattern) =>
        firstArg.toLowerCase().includes(pattern.toLowerCase())
      );
    }
    return false;
  };

  console.log = function(...args: any[]) {
    if (shouldFilterLog(...args)) return;
    originalConsoleLog.apply(console, args);
  };

  console.debug = function(...args: any[]) {
    if (shouldFilterLog(...args)) return;
    originalConsoleDebug.apply(console, args);
  };

  console.info = function(...args: any[]) {
    if (shouldFilterLog(...args)) return;
    originalConsoleInfo.apply(console, args);
  };
})();
